<template>
  <div class="view-marketplace-product">
    <div class="breadcrumbs d-flex font-weight-bold align-items-center mb-6">
      <router-link :to="{ name: 'marketplace' }" class="text-secondary">
        Mercado de Afiliação
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link
        :to="{ name: 'marketplace', params: { category: product.category } }"
        class="text-secondary"
      >
        {{ product ? product.category : "..." }}
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      <span>{{ product ? product.name : "..." }}</span>
    </div>

    <div class="row">
      <div class="col-lg-3 pl-lg-0">
        <div class="card">
          <img
            class="product-image"
            :src="require('@/assets/images/carousel-products/img-1.png')"
          />
          <div class="mt-5">
            <div class="col">
              <span>Sobre o autor</span>
            </div>
            <div class="d-flex mt-2 py-3">
              <div class="col-3 pr-0">
                <img
                  :src="require('@/assets/images/avatar-placeholder.png')"
                  class="author-image"
                />
              </div>
              <div class="col-9">
                <h6 class="mb-0">{{ product.author.name }}</h6>
                <router-link class="small" :to="{ name: 'marketplace' }"
                  >Ver página do produtor</router-link
                >
              </div>
            </div>
          </div>
          <div class="p-5">
            <div class="d-flex justify-content-between">
              <span class="label">Vendas</span>
              <strong><i class="icon-products"></i> 30%</strong>
            </div>
            <div class="d-flex justify-content-between">
              <span class="label">Avaliação</span>
              <strong><i class="icon-rating"></i> 5</strong>
            </div>
            <div class="d-flex justify-content-between">
              <span class="label">Preço máximo</span>
              <strong>R$ 87,50</strong>
            </div>
            <div class="d-flex justify-content-between">
              <span class="label">Comissão até</span>
              <strong class="text-success">R$ 10,00</strong>
            </div>
            <hr />
          </div>

          <div class="d-flex flex-column align-items-center mb-5">
            <button
              v-if="!affiliated && !affiliation_requested"
              @click="openAffiliationModal"
              class="btn btn-fixed-size btn-primary mb-3"
            >
              Afiliar-se agora
            </button>
            <button
              v-else-if="affiliation_requested"
              class="btn btn-fixed-size btn-primary mb-3"
              disabled
            >
              Afiliação solicitada
            </button>
            <button v-else class="btn btn-fixed-size btn-success mb-3">
              Ver links de divulgação
            </button>
            <button class="btn btn-fixed-size btn-outline-secondary">
              Comprar produto
            </button>
          </div>
        </div>
        <!-- <div class="mt-5">
          <strong>Conquistas</strong>
          <div class="py-5">
            <action-dispatcher action="user/getAchievements">
              <div
                v-for="(it, i) in achievementsShow"
                :key="`badge-${i}`"
                class="mb-3"
              >
                <achievement :item="it" />
              </div>
            </action-dispatcher>
          </div>
        </div> -->
      </div>
      <div class="col-lg-9">
        <h4>{{ product.name }}</h4>
        <div class="d-flex mt-5">
          <tag @click="removeTag" title="Português" class="mr-2" />
          <tag @click="removeTag" title="Design" />
        </div>
        <div class="pt-6">
          <h6 class="small-title">Regras de afiliação</h6>
          <p>{{ product.affiliation_rules }}</p>
        </div>
        <hr />
        <div class="py-3">
          <h6 class="small-title">Sobre o produto</h6>
          <p>{{ product.description }}</p>
        </div>
        <hr />
        <div class="py-3">
          <h6 class="small-title">Métricas do produto:</h6>
          <div class="row px-2">
            <div class="col-lg-4 mt-5 mt-lg-0">
              <div class="row">
                <div class="col-5 d-flex flex-column align-items-center">
                  <h6 class="font-weight-normal label">
                    Popularidade:
                  </h6>
                </div>
                <div class="col-5 pl-0 pr-0">
                  <b-progress
                    :value="product.metrics.popularity"
                    max="100"
                    class="mr-3 container-progress mt-2"
                  ></b-progress>
                </div>
                <div class="col-2 pl-0 d-flex flex-column align-items-center">
                  <small>{{ product.metrics.popularity }}%</small>
                </div>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="row">
                <div class="col-5 d-flex flex-column align-items-center">
                  <h6 class="font-weight-normal label">
                    Pontuação:
                  </h6>
                </div>
                <div class="col-5 pl-0 pr-0">
                  <b-progress
                    variant="info"
                    :value="product.metrics.points"
                    max="100"
                    class="mr-3 container-progress mt-2"
                  ></b-progress>
                </div>
                <div class="col-2 pl-0 d-flex flex-column align-items-center">
                  <small>{{ product.metrics.points }}%</small>
                </div>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="row">
                <div class="col-5 d-flex flex-column align-items-center">
                  <h6 class="font-weight-normal label">
                    Satisfação:
                  </h6>
                </div>
                <div class="col-5 pl-0 pr-0">
                  <b-progress
                    variant="warning"
                    :value="product.metrics.satisfaction"
                    max="100"
                    class="mr-3 container-progress mt-2"
                  ></b-progress>
                </div>
                <div class="col-2 pl-0 d-flex flex-column align-items-center">
                  <small>{{ product.metrics.satisfaction }}%</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="py-3">
          <h6 class="small-title">Características</h6>
          <div class="row">
            <div class="col-lg-6">
              <h6 class="font-weight-normal label">
                Idioma: <span>{{ product.details.language }}</span>
              </h6>
              <h6 class="font-weight-normal label">
                E-mail de suporte:
                <span>{{ product.details.support_email }}</span>
              </h6>
              <h6 class="font-weight-normal label">
                Assunto: <span>{{ product.details.subject }}</span>
              </h6>
            </div>
            <div class="col-lg-6">
              <h6 class="font-weight-normal label">
                Página de vendas:
                <span
                  ><router-link
                    class="font-weight-bold"
                    :to="{ to: product.details.sell_page }"
                    >{{ product.details.sell_page }}</router-link
                  ></span
                >
              </h6>
              <h6 class="font-weight-normal label">
                Forma de acesso:
                <span>{{ product.details.access_type }}</span>
              </h6>
              <h6 class="font-weight-normal label">
                Formato: <span>{{ product.details.format }}</span>
              </h6>
            </div>
          </div>
        </div>
        <hr />

        <div class="py-9">
          <products-carousel
            title="Outros produtos deste produtor"
            lightTitle
            isShort
            :items="similar"
            :perPageCustom="[
              [200, 1],
              [768, 1],
              [992, 3],
              [1300, 3]
            ]"
          />
        </div>

        <hr />
        <div class="py-3">
          <rating-carousel
            title="O que os compradores dizem"
            lightTitle
            :items="reviews"
            :rating="4.5"
            :countRatings="1.231"
          />
        </div>
        <div class="py-3">
          <promo-materials-carousel
            title="Materiais de divulgação"
            lightTitle
            :items="promoMaterials"
          />
        </div>
      </div>
    </div>

    <responsive-modal v-model="showAfiliation">
      <div class="p-5">
        <h6>Termos de Uso</h6>
        <p class="text-secondary">
          Afiliar-se ao produto <strong>{{ product.name }}</strong>
        </p>
        <hr />
        <p>
          Atenção! Antes de continuar, leia abaixo ações que
          <strong>não podem ser praticadas</strong> por quem se afilia a
          produtos na Blitzpay:
        </p>

        <div class="row px-5">
          <div class="col-1 p-0 d-flex ">
            <div class="box">
              1
            </div>
          </div>
          <div class="col-11">
            <p>
              <strong>Não envie SPAM.</strong> Não envie mensagens em massa em
              apps como WhatsApp, Telegram e outros.
            </p>
          </div>
        </div>
        <div class="row px-5">
          <div class="col-1 px-0 d-flex">
            <div class="box">
              2
            </div>
          </div>
          <div class="col-11">
            <p>
              <strong>Não use a marca Blitzpay</strong> em suas divulgações
              enquanto afiliado(a), ou que façam parecer que o produto pertence
              à Blitzpay e não ao produtor(a).
            </p>
          </div>
        </div>
        <div class="row px-5">
          <div class="col-1 px-0 d-flex">
            <div class="box">
              3
            </div>
          </div>
          <div class="col-11">
            <p>
              <strong>Não ofereça ou prometa benefícios difentes</strong> do que
              o produto oferece, nem resultados garantidos.
            </p>
          </div>
        </div>

        <hr />
        <div class="px-2">
          <checkbox :values="terms" />
        </div>

        <div class="d-flex justify-content-center mt-9">
          <button
            class="btn btn-fixed-size btn-primary"
            @click="submitAffiliation"
            :disabled="terms[0].value == false"
          >
            Quero me afiliar
          </button>
        </div>
      </div>
    </responsive-modal>

    <responsive-modal v-model="showExplainStrategy">
      <div class="p-5">
        <h6>Solicitar afiliação</h6>
        <p class="text-secondary">
          Afiliar-se ao produto <strong>{{ product.name }}</strong>
        </p>
        <hr />
        <p>
          Para aprovar sua afiliação, o(a) produtor(a) pede que você conte um
          pouco sobre sua estratégia de vendas. Conte, por exemplo, como você
          vai vender e em quais canais pretende usar, por exemplo.
        </p>
        <form-group
          textarea
          v-model="strategy"
          :rows="5"
          placeholder="Descreva sua estratégia aqui..."
        />

        <div class="d-flex justify-content-between">
          <button
            class="btn btn-fixed-size btn-outline-secondary mr-2"
            @click="showExplainStrategy = false"
          >
            Cancelar
          </button>
          <button
            class="btn btn-fixed-size btn-primary ml-2"
            :disabled="!strategy"
            @click="requestAffiliation"
          >
            Solicitar Afiliação
          </button>
        </div>
      </div>
    </responsive-modal>
    <modal-completed
      @action="showCompleted = false"
      v-model="showCompleted"
      description="Você se afiliou a este produto com sucesso! Monte sua estratégia e boas vendas!"
      btnText="Ver produto"
    />
  </div>
</template>
<script>
import Tag from "@/components/marketplace/Tag";
// import Achievement from "@/components/achievements/Achievement";
import ProductsCarousel from "@/components/marketplace/ProductsCarousel";
import PromoMaterialsCarousel from "@/components/marketplace/PromoMaterialsCarousel";
import RatingCarousel from "@/components/marketplace/RatingCarousel";
import { mapState } from "vuex";

export default {
  components: {
    Tag,
    ProductsCarousel,
    RatingCarousel,
    PromoMaterialsCarousel
    // Achievement
  },
  data() {
    return {
      affiliated: false,
      affiliation_requested: false,
      showAfiliation: false,
      showCompleted: false,
      showExplainStrategy: false,
      strategy: "",
      terms: [
        {
          id: 1,
          value: false,
          label: "Li e concordo com os Termos de Uso da afiliação"
        }
      ],
      product: {
        need_strategy: true,
        name: "Como desenhar interfaces incríveis",
        affiliation_rules: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam ornare, odio egestas elementum placerat, metus ligula faucibus nisl, in consectetur tellus erat sit amet neque. Aenean egestas nulla eu imperdiet eleifend. Curabitur commodo feugiat leo, ut sollicitudin nunc accumsan in. Sed laoreet tincidunt mattis.`,
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam ornare, odio egestas elementum placerat, metus ligula faucibus nisl, in consectetur tellus erat sit amet neque. Aenean egestas nulla eu imperdiet eleifend. Curabitur commodo feugiat leo, ut sollicitudin nunc accumsan in. Sed laoreet tincidunt mattis.",
        category: "Design",
        metrics: {
          popularity: 20,
          points: 50,
          satisfaction: 80
        },
        details: {
          language: "Português (BR)",
          support_email: "suporte@blitzpay.com.br",
          subject: "Marketing Digital",
          sell_page: "https://blitzpay.com.br",
          access_type: "Arquivo Digital",
          format: "Curso Online"
        },
        author: {
          picture: "",
          name: "Alfredo",
          page_url: "",
          sells: 30,
          rating: 5,
          max_price: 87.5,
          max_commission: 10.0
        },
        tags: [
          { id: 1, name: "Português" },
          { id: 2, name: "Design" }
        ]
      },
      similar: [
        {
          id: 1,
          name: "Atuação",
          picture: require("@/assets/images/carousel-products/img-1.png")
        },
        {
          id: 2,
          name: "Make dia",
          picture: require("@/assets/images/carousel-products/img-2.png")
        }
      ],
      reviews: [
        {
          id: 1,
          name: "Lucas Souza",
          message: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam ornare,
      odio egestas elementum placerat, metus ligula faucibus nisl, in
      consectetur tellus erat sit amet neque.`,
          date: "2021-05-10"
        },
        {
          id: 2,
          name: "Rafael Guimarães",
          message: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam ornare,
      odio egestas elementum placerat, metus ligula faucibus nisl, in
      consectetur tellus erat sit amet neque.`,
          date: "2021-05-10"
        },
        {
          id: 3,
          name: "Pedro Augustus",
          message: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam ornare,
      odio egestas elementum placerat, metus ligula faucibus nisl, in
      consectetur tellus erat sit amet neque.`,
          date: "2021-05-10"
        }
      ],
      promoMaterials: [
        { id: 1, name: "Imagens", description: "12 arquivos" },
        { id: 2, name: "Vídeos", description: "2 adicionados" },
        { id: 3, name: "Vídeos", description: "2 adicionados" }
      ]
    };
  },
  computed: {
    ...mapState("user", ["achievements"]),
    achievementsShow() {
      return (
        this.achievements &&
        this.achievements.filter(item => item.visible == true)
      );
    }
  },
  methods: {
    openAffiliationModal() {
      if (this.product.need_strategy) {
        this.showExplainStrategy = true;
      } else {
        this.showAfiliation = true;
      }
    },
    submitAffiliation() {
      this.showAfiliation = false;
      this.affiliated = true;
      this.showCompleted = true;
    },
    requestAffiliation() {
      this.affiliation_requested = true;
      this.showExplainStrategy = false;
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .checkbox {
  span {
    font-size: 14px;
  }
}
p {
  font-size: 14px;
}

.box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border: 1px solid #ff3f34;
  border-radius: 2px;
  font-weight: bold;
}

.view-marketplace-product {
  ::v-deep .progress-bar {
    border-radius: 0.25rem;
  }

  .card {
    border: none;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05);

    .icon-exclamation-outline {
      font-size: 12px;
      position: absolute;
      right: 8px;
      top: 8px;
    }

    .img-badge {
      width: 50px;
      height: 50px;
    }
  }

  .label {
    font-size: 14px;
    padding-bottom: 11px;

    span {
      font-size: 12px;
    }
  }

  .container-progress {
    height: 8px;
  }
  .product-image {
    border-radius: 4px 4px 0px 0px;
    width: 100%;
    object-fit: cover;
  }

  .author-image {
    border-radius: 8px;
    width: 100%;
    object-fit: cover;
  }

  .small-title {
    font-weight: 500;
  }

  .icon-check {
    background-color: #04c56b;
    color: #fff;
    border-radius: 25px;
    padding: 2px;
  }
}
</style>
